export const feeFields = [
	'medicalFee',
	'furtherMedicalFee',
	'mealsFee',
	'compensation',
	'caregiversFee',
	'commuteFee',
	'otherFee',
]

export const conFeeFields = [
	'conciliateMedicalFee',
	'conciliateFurtherMedicalFee',
	'conciliateMealsFee',
	'conciliateCompensation',
	'conciliateCaregiversFee',
	'conciliateCommuteFee',
	'conciliateOtherFee',
]

export const feeMap = {
	medicalFee: '医疗费',
	furtherMedicalFee: '续医费',
	mealsFee: '住院伙食补助费',
	compensation: '误工费赔偿金额',
	caregiversFee: '护理费赔偿金额',
	commuteFee: '交通费赔偿金额',
	otherFee: '其他（物损、车损等）',
}

export const feeInfo = [
	{
		id: 'medicalFee',
		actual: 'conciliateMedicalFee',
		name: '医疗费',
		desc: '医疗费赔偿金额=医疗费总金额-非医保金额',
	},
	{
		id: 'furtherMedicalFee',
		actual: 'conciliateFurtherMedicalFee',
		name: '续医费',
		desc: '后续必须的检查、二次手术费等',
	},
	{
		id: 'mealsFee',
		actual: 'conciliateMealsFee',
		name: '住院伙食补助费',
		desc: '当地住院伙食补助标准 * 实际住院天数（剔除挂床期）',
	},
	{
		id: 'compensation',
		actual: 'conciliateCompensation',
		name: '误工费赔偿金额',
		desc: '误工费赔偿金额=误工时间（天）* 伤者工资损失金额（元/天）',
	},
	{
		id: 'caregiversFee',
		actual: 'conciliateCaregiversFee',
		name: '护理费赔偿金额',
		desc: '护理费赔偿金额=误工时间（天）* 护理费标准（元/天）（护理人/护工）',
	},
	{
		id: 'commuteFee',
		actual: 'conciliateCommuteFee',
		name: '交通费赔偿金额',
		desc: '',
	},
	{
		id: 'otherFee',
		actual: 'conciliateOtherFee',
		name: '其他（物损、车损等）',
		desc: '本次事故造成的受害者的机动车、非机动、物品损失的赔偿金额',
	},
]

export function capUpperCase(str) {
	return str.slice(0, 1).toUpperCase() + str.slice(1)
}
